// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomEntity_root__1QQmU","content":"CustomEntity_content__Yhg0K","left":"CustomEntity_left__1mKrA","right":"CustomEntity_right__3Vv_I"};